(function () {
  var FREE_SHIPPING_THRESHOLD = 12000;
  var UPSELL_VARIANT_ID = 43691840405597;

  var drawer = document.getElementById('lui-cart-drawer');
  var overlay = document.getElementById('lui-cart-overlay');
  var closeBtn = document.getElementById('lui-cart-close');
  var body = document.getElementById('lui-cart-body');
  var footer = document.getElementById('lui-cart-footer');
  var subtotalEl = document.getElementById('lui-cart-subtotal');
  var shippingNote = document.getElementById('lui-shipping-note');
  var isUS = Intl.DateTimeFormat().resolvedOptions().timeZone.startsWith('America');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    // Fetch both the cart JSON (for subtotal/footer) and the rendered section HTML (for items)
    Promise.all([
      fetch('/cart.js').then(function(r) { return r.json(); }),
      fetch('/?section_id=lui-cart-items').then(function(r) { return r.text(); })
    ]).then(function(results) {
      var cart = results[0];
      var html = results[1];

      // Update items area
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newItems = doc.querySelector('.lui-cart-items-wrap');
      if (newItems) {
        var existing = body.querySelector('.lui-cart-items-wrap');
        if (existing) {
          existing.replaceWith(newItems);
        } else {
          body.innerHTML = '';
          body.appendChild(newItems);
        }
      }

      // Update footer
      if (cart.item_count === 0) {
        footer.style.display = 'none';
      } else {
        footer.style.display = 'flex';
        subtotalEl.textContent = formatMoney(cart.total_price);
        if (shippingNote) {
          shippingNote.innerHTML = isUS
            ? (cart.total_price >= FREE_SHIPPING_THRESHOLD
                ? 'Shipping: Free!<br>Taxes calculated at checkout.'
                : 'Flat rate shipping $6.95.<br>Taxes calculated at checkout.')
            : 'International shipping calculated at checkout.';
        }
      }

      bindEvents();
    }).catch(function() {
      body.innerHTML = '<p class="lui-cart-drawer__empty">Unable to load bag.</p>';
    });
  }

  function bindEvents() {
    body.querySelectorAll('.lui-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateItem(btn.dataset.key, parseInt(btn.dataset.qty));
      });
    });

    body.querySelectorAll('.lui-cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateItem(btn.dataset.key, 0);
      });
    });

    var upsellBtn = document.getElementById('lui-upsell-btn');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function() {
        upsellBtn.textContent = '...';
        upsellBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: upsellBtn.dataset.variantId, quantity: 1 })
        })
          .then(function() { refreshCart(); })
          .catch(function() { refreshCart(); });
      });
    }
  }

  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function() { refreshCart(); });
  }

  var cartLink = document.querySelector('a.lui-header__icon-link[aria-label="Cart"]');
  if (cartLink) {
    cartLink.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('[action="/cart/add"]')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function() { openDrawer(); })
      .catch(function() { openDrawer(); });
  });

  document.addEventListener('lui:open-cart', openDrawer);

  // Bind events for initially-rendered items
  bindEvents();
})();